import { Card, CardContent } from "@/shared/ui/card";
import { Skeleton } from "@/shared/ui/skeleton";
import { Search } from "lucide-react";

export function PropertySiteAttributesSkeleton() {
  return (
    <div className="space-y-6 lg:flex lg:h-full lg:flex-col lg:space-y-0 lg:gap-6 lg:overflow-hidden">
      <div className="flex items-start justify-between gap-4 lg:flex-shrink-0">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-5 rounded" />
            <Skeleton className="h-6 w-36" />
          </div>
          <Skeleton className="h-4 w-56" />
        </div>
        <Skeleton className="h-9 w-28 rounded-md" />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:min-h-0 lg:flex-1 lg:grid-cols-[350px_1fr] lg:overflow-hidden">
        <Card className="h-fit border border-border/50 bg-card/50 lg:h-full lg:max-h-full lg:overflow-hidden">
          <CardContent className="space-y-4 p-4 lg:flex lg:h-full lg:flex-col">
            <div className="space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-40" />
            </div>

            <div className="relative">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>

            <div className="space-y-1 lg:min-h-0 lg:flex-1 lg:overflow-hidden lg:px-1 lg:py-1">
              {Array.from({ length: 9 }).map((_, index) => (
                <div key={index} className="flex items-center gap-3 rounded-lg px-3 py-2">
                  <Skeleton className="h-8 w-8 shrink-0 rounded-lg" />
                  <Skeleton className="h-4 flex-1" />
                  <Skeleton className="h-3 w-5" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <div className="space-y-4 lg:min-h-0 lg:overflow-hidden lg:pr-2">
          <div className="space-y-2">
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-4 w-28" />
          </div>

          {Array.from({ length: 4 }).map((_, sectionIndex) => (
            <Card key={sectionIndex} className="overflow-hidden border-border/60 bg-card/60">
              <CardContent className="p-0">
                <div className="flex items-center justify-between border-b border-border/40 px-4 py-3">
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-4 w-4 rounded" />
                    <Skeleton className="h-8 w-8 rounded-lg" />
                    <Skeleton className="h-5 w-40" />
                  </div>
                  <Skeleton className="h-5 w-14 rounded-full" />
                </div>
                <div className="space-y-3 p-4">
                  {Array.from({ length: 3 }).map((_, fieldIndex) => (
                    <div key={fieldIndex} className="grid grid-cols-1 gap-2 rounded-lg border border-border/30 p-3 sm:grid-cols-[180px_1fr]">
                      <Skeleton className="h-4 w-28" />
                      <Skeleton className="h-4 w-full" />
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
